<template>
  <div
    v-if="orgName"
    class="d-flex w-100 bg-white align-items-center justify-content-between py-2 sticky-header"
  >
    <div>
      <div class="primary-title">
        {{ orgName }}
      </div>
      <div
        v-if="comment && comment.trim() !== '-'"
        style="color: #333; margin-top: -2px"
      >
        {{ comment }}
      </div>
      <div
        v-if="ordersComment && ordersComment.trim() !== '-'"
        style="color: #333; margin-top: -2px"
      >
        {{ ordersComment }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    orgName: {
      type: String,
      default: '',
    },
    comment: {
      type: String,
      default: '',
    },
    ordersComment: {
      type: String,
      default: '',
    },
    weekDayName: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.sticky-header {
  position: sticky;
  left: 0;
  top: 0;
}

.primary-title {
  font-size: 24px;
  font-weight: 600;
  color: #3F6FFB;
}

.product-number {
  width: 200px;
  font-weight: 500;
  text-align: right;
}
</style>
